import { AxiosResponse, CancelToken } from 'axios';
import internalApiClient from '~/app/shared/util/api/internalApiClient';
import { Dimension } from '../types';

export function getAllDimensions(cancelToken?: CancelToken): Promise<AxiosResponse<Dimension[]>> {
    return internalApiClient.get<Dimension[]>('dimension/GetAll', { cancelToken, params: { active: false } });
}

export function createDimension(dimension: Dimension): Promise<AxiosResponse> {
    return internalApiClient.post<undefined, AxiosResponse, Dimension>('dimension', dimension);
}

export function getDimensionById(id: number, cancelToken?: CancelToken): Promise<AxiosResponse<Dimension>> {
    return internalApiClient.get<Dimension>(`dimension/${id}?includeBarred=true`, { cancelToken });
}

type UpdateDimensionType = Pick<Dimension, 'name' | 'active'>;
export function updateDimension(dimension: Dimension): Promise<AxiosResponse> {
    return internalApiClient.put<undefined, AxiosResponse, UpdateDimensionType>(`dimension/${dimension.id}`, dimension);
}

export function deleteDimension(id: number): Promise<AxiosResponse> {
    return internalApiClient.delete(`dimension/${id}`);
}
